import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextContentSl = () => {
    return (
        <HighlightedText
            text="OSVOJILI STE 400 BREZPLAČNIH VRTLJAJEV"
            highlights={[{ word: '400' }]}
            breakAfterWords={['STE', 'BREZPLAČNIH']}
            className={styles.text_content}
        />
    )
}
